var exports = {
  "kL": "WebhookListItem.module__container___SW9ZOE",
  "aY": "WebhookListItem.module__headerButton___SW9ZOE",
  "kb": "WebhookListItem.module__left___SW9ZOE",
  "Jb": "WebhookListItem.module__avatarLarge___SW9ZOE",
  "fI": "WebhookListItem.module__textBlock___SW9ZOE",
  "$": "WebhookListItem.module__titleRow___SW9ZOE",
  "UU": "WebhookListItem.module__name___SW9ZOE",
  "ML": "WebhookListItem.module__channelTag___SW9ZOE",
  "KW": "WebhookListItem.module__metaRow___SW9ZOE",
  "K9": "WebhookListItem.module__channelTagMobile___SW9ZOE",
  "ai": "WebhookListItem.module__chevron___SW9ZOE",
  "hg": "WebhookListItem.module__chevronExpanded___SW9ZOE",
  "zH": "WebhookListItem.module__details___SW9ZOE",
  "J1": "WebhookListItem.module__detailsRow___SW9ZOE",
  "Mc": "WebhookListItem.module__avatarColumn___SW9ZOE",
  "Pf": "WebhookListItem.module__label___SW9ZOE",
  "_Q": "WebhookListItem.module__avatarPreview___SW9ZOE",
  "OA": "WebhookListItem.module__fields___SW9ZOE",
  "EN": "WebhookListItem.module__fieldsRow___SW9ZOE",
  "ch": "WebhookListItem.module__fieldGrow___SW9ZOE",
  "o1": "WebhookListItem.module__actions___SW9ZOE",
  "Dy": "WebhookListItem.module__avatarActions___SW9ZOE",
  "B": "WebhookListItem.module__urlWrapper___SW9ZOE",
  "UQ": "WebhookListItem.module__monoInput___SW9ZOE",
  "Bx": "WebhookListItem.module__iconSmall___SW9ZOE",
  "xv": "WebhookListItem.module__truncate___SW9ZOE",
};

module.exports = exports;
